/* Functional enhancements only. No layout or brand changes. */
(() => {
  // Keep the modal in browser history without inventing a product URL.
  let dialogHistory=false,closingFromHistory=false;
  window.haydersOpenDialog=dialog=>{
    if(dialog.open)return;
    dialog.showModal();
    if(!dialogHistory){history.pushState({...history.state,haydersDialog:dialog.id},'',location.href);dialogHistory=true;}
  };
  window.addEventListener('popstate',()=>{
    if(dialogHistory){closingFromHistory=true;document.querySelectorAll('dialog[open]').forEach(d=>d.close());closingFromHistory=false;dialogHistory=false;}
  });
  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('[data-design-form] [name="_next"]').forEach(input=>{const target=new URL(input.value,location.origin);target.protocol=location.protocol;target.host=location.host;input.value=target.href;});
    document.querySelectorAll('dialog').forEach(dialog=>{
      dialog.addEventListener('close',()=>{
        if(!closingFromHistory&&dialogHistory&&history.state?.haydersDialog===dialog.id){dialogHistory=false;history.back();}
      });
    });
    document.querySelectorAll('.mobile-menu').forEach(menu=>{
      const summary=menu.querySelector('summary');
      const sync=()=>{summary.setAttribute('aria-expanded',String(menu.open));summary.setAttribute('aria-label',menu.open?'Close navigation':'Open navigation');};
      menu.addEventListener('toggle',sync);sync();
      menu.addEventListener('click',e=>{if(e.target.closest('a'))menu.open=false;});
      document.addEventListener('click',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false;});
      menu.addEventListener('keydown',e=>{
        if(e.key==='Escape'){menu.open=false;summary.focus();}
        if(e.key==='Tab'&&menu.open){const items=[summary,...menu.querySelectorAll('a[href],button')],first=items[0],last=items[items.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
      });
    });
    document.querySelectorAll('.nav-dropdown').forEach(menu=>{
      menu.addEventListener('focusout',()=>setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},0));
      document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.open=false;});
    });
  });
  // Prevent invalid or offline uploads, retain data on failed handoff and allow retry.
  document.addEventListener('submit',event=>{
    const form=event.target;if(!form.matches('[data-design-form]'))return;
    if(navigator.onLine===false){event.preventDefault();form.querySelector('[data-enquiry-status]').textContent='You appear to be offline. Reconnect, then send your design again. Your details remain here.';return;}
    if(event.defaultPrevented)return;
    if(form.dataset.sending==='true'){event.preventDefault();return;}
    queueMicrotask(()=>{
      if(event.defaultPrevented)return;
      form.dataset.sending='true';form.setAttribute('aria-busy','true');
      const button=form.querySelector('[type=submit]');button.dataset.originalLabel=button.textContent;button.disabled=true;button.textContent='Opening secure submission…';
      form._resetTimer=setTimeout(()=>resetForm(form,true),20000);
    });
  });
  function resetForm(form,uncertain=false){
    clearTimeout(form._resetTimer);form.dataset.sending='false';form.setAttribute('aria-busy','false');
    const button=form.querySelector('[type=submit]');button.disabled=false;if(button.dataset.originalLabel)button.textContent=button.dataset.originalLabel;
    if(uncertain)form.querySelector('[data-enquiry-status]').textContent='Submission is not confirmed. If the security page did not open, check your connection and try again, or contact us on WhatsApp.';
  }
  window.addEventListener('pageshow',()=>document.querySelectorAll('[data-design-form]').forEach(form=>resetForm(form,form.dataset.sending==='true')));
  document.addEventListener('click',e=>{
    const link=e.target.closest('a[href^="https://wa.me/"]');if(!link)return;
    if(!/^https:\/\/wa\.me\/[1-9]\d{7,14}(?:\?|$)/.test(link.href)){
      e.preventDefault();const status=document.querySelector('[data-bag-status]');if(status)status.textContent='WhatsApp enquiries are temporarily unavailable. Please use the email link in the footer.';
    }
  });
})();
